import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MuiIconModule } from '../icon';
import { MuiTabGroup } from './enclosed/tab-group/mui-tab-group.component';
import { MuiTab } from './enclosed/tab/mui-tab.component';
import { MuiTabNavLinkDirective } from './routed/tab-nav-link/mui-tab-nav-link.directive';
import { MuiTabNav } from './routed/tab-nav/mui-tab-nav.component';

@NgModule({
  declarations: [
    MuiTabGroup,
    MuiTab,
    MuiTabNav,
    MuiTabNavLinkDirective
  ],
  imports: [
    CommonModule,
    MuiIconModule,
    RouterModule
  ],
  exports: [
    MuiTabGroup,
    MuiTab,
    MuiTabNav,
    MuiTabNavLinkDirective
  ]
})
export class MuiTabsModule { }
